// Workflow-related constants and helpers.
// `WorkflowType` and `PQCWorkflowVariant` remain in `@/constants/dispositions`
// for historical reasons; new workflow metadata lives here.

import { WorkflowType } from '@/constants/dispositions';

// Display labels for workflow types. Used in cross-program views (e.g. My Cases)
// where the workflow type needs to be surfaced as a column.
export const WORKFLOW_TYPE_LABELS: Record<string, string> = {
  [WorkflowType.MEDBV]: 'MedBV',
  [WorkflowType.PBM]: 'PharmBV',
  [WorkflowType.RECALL_SCHEDULER]: 'Recall Scheduler',
  [WorkflowType.REFERRAL_SCHEDULER]: 'Referral Scheduler',
  [WorkflowType.BENEFIT_VERIFICATION]: 'Benefit Verification',
  [WorkflowType.PQC]: 'PQC',
  [WorkflowType.MEDICARE_HUMAN]: 'Medicare Human',
  [WorkflowType.UNIFIEDMEDBV]: 'MedBV',
  // BHO has its own "bho" skill, like pa_status (BV-2476), so it needs a label of
  // its own: the skills picker de-dups by label and would otherwise fold it into
  // MedBV.
  [WorkflowType.BHO]: 'BHO',
  // MEDBHOBV (BV-2328) is served by the medbv skill too, so it shares the label.
  [WorkflowType.MEDBHOBV]: 'MedBV',
  [WorkflowType.TRANSPORTATION]: 'Transportation',
  [WorkflowType.PA_STATUS_PBM]: 'PA Status PBM',
  [WorkflowType.PA_STATUS_MEDBV]: 'PA Status MedBV',
  [WorkflowType.REFILL]: 'Refill',
};

// Workflow types whose case payload carries a payor slug at `input_data.data.payor_name`.
// Used to decide when the Payor column is meaningful in cross-program views.
export const PAYOR_WORKFLOW_TYPES: Set<string> = new Set([
  WorkflowType.PBM,
  WorkflowType.MEDBV,
  WorkflowType.UNIFIEDMEDBV,
  WorkflowType.BHO,
  WorkflowType.MEDBHOBV,
  WorkflowType.PA_STATUS_PBM,
  WorkflowType.PA_STATUS_MEDBV,
]);

export const workflowTypeLabel = (type?: string | null): string => {
  if (!type) return 'N/A';
  if (WORKFLOW_TYPE_LABELS[type]) return WORKFLOW_TYPE_LABELS[type];
  return type
    .split('_')
    .map(w => (w ? w.charAt(0).toUpperCase() + w.slice(1) : ''))
    .join(' ');
};
